/** Gap between the floating row and the in-flow composer (`mb-2` on the bar). */
export const FLOATING_BAR_BOTTOM_GAP_PX = 8

/** `h-9` control row. Floor while the slot is up but still unmeasured. */
export const FLOATING_BAR_MIN_HEIGHT_PX = 36

/** Padding under the row's occupants (`pb-1` on the bar). */
export const FLOATING_BAR_INNER_BOTTOM_PAD_PX = 4

/**
 * Tallest a floating-bar occupant may grow. The bar is anchored to the footer
 * and nothing clips it, so a card taller than this runs behind the toolbar and
 * out of the panel. `undefined` until the region has been measured.
 */
export function floatingBarContentMaxHeight(viewAreaHeight: number, headerGutter: number): number | undefined {
  if (viewAreaHeight <= 0) {
    return undefined
  }
  return Math.max(0, viewAreaHeight - headerGutter - FLOATING_BAR_BOTTOM_GAP_PX - FLOATING_BAR_INNER_BOTTOM_PAD_PX)
}

/** Height view bodies reserve for the floating row. A visible slot never publishes 0. */
export function publishedFloatingBarHeight(measuredHeight: number, reservesRoom: boolean): number {
  if (!reservesRoom) {
    return 0
  }
  return Math.max(measuredHeight, FLOATING_BAR_MIN_HEIGHT_PX) + FLOATING_BAR_BOTTOM_GAP_PX
}
